import React from 'react';
import Header from '@amzn/awsui-components-console/header';
import ColumnLayout from '@amzn/awsui-components-console/column-layout';
import Container from '@amzn/awsui-components-console/container';
import Box from '@amzn/awsui-components-console/box';
import ShowSnowStatus from './ShowSNOWStatus';
import { TaskExecutionData } from '@amzn/snow-nxt-workflow-service-typescript-client';
import './TaskExecutionSummary.scss';

interface TaskExecutionSummaryProps {
	taskExecutionData: TaskExecutionData[];
	entityName: string;
	onStatusClick?: (status: string) => void;
}

export default function TaskExecutionSummary({taskExecutionData, entityName, onStatusClick}: TaskExecutionSummaryProps) {

	const filterItems = (items: TaskExecutionData[], filterType: string[]) => {
		return items.filter(
			(item) =>
				item.status != null &&
				filterType.includes(item.status) &&
				(entityName === '' || (item.entities != null && item.entities.includes(entityName)))
		);
	};

	const summaryStats = [
		{
			id: 'TOTAL',
			label: 'Total',
			count: entityName === '' 
				? taskExecutionData.length
				: taskExecutionData.filter(
					(item) =>
						item.entities != null &&
						item.entities.includes(entityName)
				).length,
			color: 'blue',
			tab: 'executedTasks',
			clickable: true,
		},
		{
			id: 'COMPLETED',
			label: 'Completed',
			count: filterItems(taskExecutionData, ['COMPLETED']).length,
			color: 'green',
			tab: 'executedTasks',
			clickable: true,
		},
		{
			id: 'RUNNING',
			label: 'Running',
			count: filterItems(taskExecutionData, ['RUNNING', 'IN_PROGRESS', 'SCHEDULED_FOR_DEPLOYMENT', 'PENDING_APPROVAL', 'PENDING_REVIEW']).length,
			color: 'blue',
			tab: 'executedTasks',
			clickable: true,
		},
		{
			id: 'WAITING',
			label: 'Waiting',
			count: filterItems(taskExecutionData, ['WAITING']).length,
			color: 'grey',
			tab: 'Waiting',
			clickable: true,
		},
		{
			id: 'OVERRIDEN',
			label: 'Overriden',
			count: filterItems(taskExecutionData, ['OVERRIDEN']).length,
			color: 'grey',
			tab: 'executedTasks',
			clickable: true,
		},
		{
			id: 'FAILED',
			label: 'Failed',
			count: filterItems(taskExecutionData, ['FAILED']).length,
			color: 'red',
			tab: 'executedTasks',
			clickable: true,
		},
		{
			id: 'SKIPPED',
			label: 'Skipped',
			count: filterItems(taskExecutionData, ['SKIPPED']).length,
			color: 'grey',
			tab: 'executedTasks',
			clickable: false,
		},
		{
			id: 'RE_RUN',
			label: 'Re-Run',
			count: filterItems(taskExecutionData, ['RE_RUN', 'READY']).length,
			color: 'blue',
			tab: 'executedTasks',
			clickable: true,
		},
	];

	const handleCardClick = (stat: typeof summaryStats[0]) => {
		if (stat.clickable && onStatusClick) {
			onStatusClick(stat.id);
		}
	};

	return (
		<Container
			header={<Header variant="h3"><strong>Task Execution Summary</strong></Header>}
		>
			<ColumnLayout columns={4}>
				{summaryStats.map((stat) => {
					return (
						<div
							key={stat.id}
							className={`task-execution-card task-execution-card--${stat.color}`}
							onClick={() => handleCardClick(stat)}
							role={stat.clickable ? 'button' : undefined}
							tabIndex={stat.clickable ? 0 : undefined}
							onKeyDown={(e) => {
								if (stat.clickable && (e.key === 'Enter' || e.key === ' ')) {
									e.preventDefault();
									handleCardClick(stat);
								}
							}}
							style={{ cursor: stat.clickable ? 'pointer' : 'default' }}
						>
							<Box fontSize="body-s">
								<ShowSnowStatus status={stat.id} />
							</Box>
							<Box fontSize="heading-l" fontWeight="bold">
								<span className="task-execution-card__count">{stat.count}</span>
							</Box>
						</div>
					);
				})}
			</ColumnLayout>
		</Container>
	);
}
